import { useState, useEffect } from "react";
import "./App.css";
import TabellaRecord from "./components/TabellaRecord";
import LoginForm from "./components/LoginForm";
import StoricoAttivita from "./components/StoricoAttivita"; // NUOVO: Componente storico attività
import { APICall, authAPI } from "./api";
import { Button, Loader, Label, Dropdown, Icon } from "semantic-ui-react";
import { setAuthToken } from "./utils/auth";
import {
  getUserCurrentlyLogged,
  getUserRole,
  isUserAdmin,
} from "./utils/userCurrentlyLogged";
import GestioneUtenti from "./components/GestioneUtenti";
import MappaOperatori from "./components/MappaOperatori";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showUserManagement, setShowUserManagement] = useState(false);
  const [showActivityHistory, setShowActivityHistory] = useState(false); // NUOVO: Stato per modale storico attività
  const [showMappa, setShowMappa] = useState(false);

  // Verify session by attempting to fetch data
  useEffect(() => {
    const verifySession = async () => {
      try {
        const token = localStorage.getItem("auth_token");
        if (token) {
          setAuthToken(token);
          await APICall.get("/"); // Try to fetch initial data
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log("Not authenticated:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifySession(); // Call the function
  }, []);

  const handleLoginSuccess = (userData) => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await authAPI.logout();
      setIsAuthenticated(false);
    } catch (error) {
      console.error("Errore durante il logout:", error);
      // Forziamo il logout lato client
      setIsAuthenticated(false);
    }
  };

  if (isLoading) {
    return <Loader active>Verifica accesso...</Loader>;
  }

  if (!isAuthenticated) {
    return <LoginForm onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <>
      <div className="header-container">
        <div className="logo-container">
          <img
            className="logo-img"
            src="/labcare-favicon-512.png"
            alt="Lab Care Logo"
          />
        </div>
        <div className="title-container">
          <h1 className="title">Gestionale Anagrafica Operatori</h1>
        </div>
        <div className="user-container">
          <Dropdown
            trigger={
              <Label className="label-user" as="a" image>
                <img className="user-img" src="/user.jpg" />
                <div className="user-name-container">
                  {getUserCurrentlyLogged()}{" "}
                  <Icon name="chevron down" size="small" />
                </div>
              </Label>
            }
            pointing="top right"
            icon={null}
          >
            <Dropdown.Menu>
              <Dropdown.Header content={`Ruolo ${getUserRole()}`} />
              <Dropdown.Divider />
              {isUserAdmin() && (
                <Dropdown.Item
                  icon="users"
                  text="Gestione Utenti"
                  onClick={() => setShowUserManagement(true)}
                />
              )}
              {/* NUOVO: Voce menu per storico attività (TEMPORANEAMENTE solo per admin). Per riabilitare la possibilità di visionare il proprio storico attività per il singolo utente NON admin, eliminare il controllo isAdmin() dal blocco di codice dello storico attività.   */}
              {isUserAdmin() && (
                <Dropdown.Item
                  icon="history"
                  text="Storico Attività"
                  onClick={() => setShowActivityHistory(true)}
                />
              )}
              <Dropdown.Item
                icon="map"
                text="Mappa Operatori"
                onClick={() => setShowMappa(true)}
              />
              <Dropdown.Item
                icon="sign-out"
                text="Logout"
                onClick={handleLogout}
                negative
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <TabellaRecord />
      {/* Modale gestione utenti (solo admin) */}
      {isUserAdmin() && (
        <GestioneUtenti
          open={showUserManagement}
          onClose={() => setShowUserManagement(false)}
        />
      )}
      {/* NUOVO: Modale storico attività (tutti gli utenti, ma con permessi differenziati) */}
      <StoricoAttivita
        open={showActivityHistory}
        onClose={() => setShowActivityHistory(false)}
      />
      <MappaOperatori open={showMappa} onClose={() => setShowMappa(false)} />
    </>
  );
}

export default App;
